import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/login/admin',
    method: 'post',
    data
  })
}

export function getInfoAdmin() {
    return request({
        url: '/user/getloginuser',
        method: 'post',
    })
}
